export default __webpack_public_path__ + "static/media/uk_ad_banner.20260f82.jpg";